import {

  useState

} from 'react';

import {

  useNavigate

} from 'react-router-dom';

import {

  EmailAuthProvider,

  reauthenticateWithCredential

} from 'firebase/auth';

import {

  auth

} from '../../config/firebase';

export default function
AdminSecurityPage() {

  const navigate =
    useNavigate();

  const [password, setPassword] =
    useState('');
  const [feedback, setFeedback] = useState('');

  const handleVerify =
  async () => {

    try {

      const user =
        auth.currentUser;

      if (!user || !user.email) {

        setFeedback('Usuário não autenticado.');

        return;
      }

      const credential =

        EmailAuthProvider.credential(

          user.email,

          password
        );

      await reauthenticateWithCredential(

        user,

        credential
      );

      sessionStorage.setItem(

        'admin_verified',

        'true'
      );

      sessionStorage.setItem(

  'admin_verified_at',

  Date.now().toString()
);

      navigate('/admin');

    } catch (error) {

      console.error(error);

      setFeedback('Senha incorreta.');
    }
};
  return (

    <div className="min-h-screen bg-[#020817] flex items-center justify-center px-6">

      <div className="w-full max-w-md bg-[#0f172a] border border-white/10 rounded-2xl p-8">

        <h1 className="text-2xl font-bold text-white mb-2">

          Verificação Admin

        </h1>

        <p className="text-gray-400 mb-6">

          Confirme sua identidade
          para acessar o painel.

        </p>

        {feedback && (
          <div className="mb-4 rounded-lg border border-red-500/40 bg-red-950/50 px-3 py-2 text-sm text-red-100" role="alert">
            {feedback}
          </div>
        )}

        <input

          type="password"

          placeholder="Senha admin"

          value={password}

          onChange={(e) =>
            setPassword(
              e.target.value
            )
          }

          className="w-full bg-[#020817] border border-white/10 rounded-xl px-4 py-3 text-white outline-none mb-4"
        />

        <button

          onClick={handleVerify}

          className="w-full bg-white text-black font-semibold py-3 rounded-xl hover:opacity-90 transition-all"
        >

          Verificar acesso

        </button>

      </div>

    </div>
  );
}
